import { defineMessages } from "@/i18n";
import en from "./en";

export const linkPreviewFrameMessages = defineMessages(
  "frames-link-preview",
  en,
);
